// SpotlightCard.js — Superfície com um brilho suave que segue o cursor.
// Equivalente ao `SpotlightCard` do react-bits, adaptado aos tokens do site.
//
// O brilho usa `--c-orange` (o laranja da marca) em opacidade baixa, então
// funciona no tema claro e no escuro sem nenhuma cor fixa no código.
// Em telas de toque nada acontece — e nada quebra: o gradiente só é pintado
// depois do primeiro movimento de mouse.
import React, { useRef, useState } from "react";

const SpotlightCard = ({
  children,
  className = "",
  intensidade = 0.14,
  raio = 260,
  ...rest
}) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(null);

  const mover = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    setPos({ x: e.clientX - r.left, y: e.clientY - r.top });
  };

  return (
    <div
      ref={ref}
      onMouseMove={mover}
      onMouseLeave={() => setPos(null)}
      className={"relative overflow-hidden " + className}
      {...rest}
    >
      {pos && (
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 transition-opacity duration-300"
          style={{
            background: `radial-gradient(${raio}px circle at ${pos.x}px ${pos.y}px, rgb(var(--c-orange) / ${intensidade}), transparent 65%)`,
          }}
        />
      )}
      <div className="relative">{children}</div>
    </div>
  );
};

export default SpotlightCard;
